import { PALETTE, FONT_DISPLAY, FONT_MONO } from "@/components/cobrain/tokens";

/* Says out loud who this is not for. On a page with no named clients,
   visible willingness to disqualify is the strongest trust move available. */

const GOOD = [
  "1 to 30 people, owner still close to the work",
  "Real volume in calls, quotes, bookings or inbox",
  "Someone internal who can answer questions for an hour a week",
  "Willing to change a process, not just bolt on a tool",
];

const NOT = [
  "Pre-revenue, or no repeatable workflow yet",
  "Looking for a twelve-month transformation roadmap",
  "Needs procurement, security review and a steering committee",
  "Wants a chatbot on the website and nothing else",
];

function Col({ label, tone, items, dark }: { label: string; tone: "good" | "not"; items: string[]; dark?: boolean }) {
  const good = tone === "good";
  const bodyColor = dark ? "rgba(255,255,255,0.74)" : PALETTE.ink2;
  return (
    <div style={{
      padding: "22px 22px 24px", borderRadius: 18,
      background: good
        ? (dark ? "rgba(196,130,58,0.14)" : "rgba(196,130,58,0.07)")
        : (dark ? "rgba(255,255,255,0.05)" : PALETTE.card),
      border: `1px solid ${good ? "rgba(196,130,58,0.32)" : (dark ? "rgba(255,255,255,0.12)" : PALETTE.line)}`,
      color: dark ? "#fff" : PALETTE.ink,
    }}>
      <div style={{
        fontFamily: FONT_MONO, fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase",
        color: good ? (dark ? PALETTE.amberSoft : PALETTE.amber) : (dark ? "rgba(255,255,255,0.5)" : PALETTE.muted),
        fontWeight: 700, marginBottom: 10,
      }}>
        {good ? "Good fit" : "Not us — yet"}
      </div>
      <h3 style={{ fontFamily: FONT_DISPLAY, fontWeight: 400, fontSize: 24, margin: "0 0 16px", letterSpacing: "-0.01em" }}>
        {label}
      </h3>
      <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 11 }}>
        {items.map((t) => (
          <li key={t} style={{ display: "flex", gap: 10, fontSize: 14.5, lineHeight: 1.5, color: bodyColor }}>
            <span aria-hidden style={{
              flexShrink: 0, fontWeight: 700,
              color: good ? (dark ? PALETTE.amberSoft : PALETTE.amber) : (dark ? "rgba(255,255,255,0.32)" : "rgba(0,0,0,0.28)"),
            }}>{good ? "✓" : "—"}</span>
            <span style={{ opacity: good ? 1 : 0.82 }}>{t}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function FitCheck({ tone }: { tone?: "light" | "dark" } = {}) {
  const dark = tone === "dark";
  return (
    <div className="svc-fit-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
      <Col label="You'll get value out of a call" tone="good" items={GOOD} dark={dark} />
      <Col label="We'd tell you to wait" tone="not" items={NOT} dark={dark} />
    </div>
  );
}

export default FitCheck;
